import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import request  from '@/request'
import url from '@/assets/js/urls.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/js/flexible'
Vue.use(ElementUI)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'//这里注意具体看使用的版本是否需要引入样式，以及具体位置。
Vue.use(VueAwesomeSwiper, /* { default global options } */)
import '@/permission'
Vue.config.productionTip = false
Vue.prototype.$url = url
Vue.prototype.$request = request

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
